import React, { FunctionComponent, useMemo } from 'react'
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux'
import { History } from 'history'
import { useTranslation } from 'react-i18next'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'Types/index'
import { scheduleCampaign, campaignsList } from 'Router/routes'
import Alert from 'Shared/components/Alert'
import {
  getAmountOfCampaigns,
  getCampaignToSchedule,
  getCampaigns,
} from 'Redux/selectors/campaigns'
import { getUserSelector } from 'Redux/selectors/auth'
import { campaignScheduleStartEvent } from 'Helpers/tagManager'
import { CampaignItem } from '../../../Types'

type ApprovedCampaignAlertProps = {
  campaign: CampaignItem
  updateScheduledCampaign: (campaign: CampaignItem) => void
  history: History
}

const ApprovedCampaignAlert: FunctionComponent<ApprovedCampaignAlertProps> = ({
  campaign,
  campaign: { id, trackTitle },
  updateScheduledCampaign,
  history,
}) => {
  const { t } = useTranslation()
  const user = useSelector(getUserSelector)
  const campaigns = useSelector(getCampaigns)
  const campaignDetails = useSelector(getCampaignToSchedule)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)

  const campaignDetailsType = useMemo(
    () => campaigns.find(el => el.id === campaign.id && el.type)?.type,
    [campaigns, campaign.id]
  )

  const campaignIsFeed = useMemo(
    () => campaigns.find(el => el.id === campaign.id && el.is_feed)?.is_feed,
    [campaigns, campaign.id]
  )

  const handleScheduleCampaign = () => {
    updateScheduledCampaign(campaign)

    campaignScheduleStartEvent(
      campaignDetailsType,
      campaignDetails?.genres.map(genre => genre.name).join(),
      campaignDetails?.languages.map(language => language.name).join(),
      campaign.id,
      CampaignPlatformTypeEnum.SPOTIFY,
      user.id,
      amountOfCampaigns,
      campaignIsFeed || false
    )
    history.push(`${campaignsList}${scheduleCampaign}/${id}`)
  }

  return (
    <Alert color="success" icon>
      <div className="alert__text">
        <div className="alert__title">{t('campaignsPage.goodNews')}</div>
        &quot;{trackTitle}&quot; {t('campaignsPage.isWaiting')}
      </div>
      <button
        type="button"
        className="success__btn"
        color="success"
        onClick={handleScheduleCampaign}
      >
        {t('campaignsPage.launchCampaign')}
      </button>
    </Alert>
  )
}

export default ApprovedCampaignAlert
